import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useLazyGetDesignInfoQuery, useLazyGetPatentInfoQuery, useLazyGetTradeMarkInfoQuery } from "../../../api/agent";
import { Storage } from "../../../modules/Storage";
import { useAppDispatch } from "../../../store";
import { setAlertModal } from "../../../store/slice/modal";

const TABS = {
    PATENT: "patent",
    DESIGN: "design",
    TRADEMARK: "trademark",
};

const Contents = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLogin] = useState(Storage.get("accountKey") ? true : false);
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const role = Storage.get("role");
    const myAttorneyNo = Storage.get("agentNo");

    // tabs
    const [activeTab, setActiveTab] = useState(TABS.PATENT);

    // inputs per tab
    const [patentNo, setPatentNo] = useState("");
    const [designNo, setDesignNo] = useState("");
    const [trademarkNo, setTrademarkNo] = useState("");

    const [triggerPatentSearch, { data, error, isFetching }] = useLazyGetPatentInfoQuery();
    const [triggerDesignSearch, { data: designData, error: designError, isFetching: designIsFetching }] = useLazyGetDesignInfoQuery();
    const [triggerTrademarkSearch, { data: trademarkData, error: trademarkError, isFetching: trademarkIsFetching }] = useLazyGetTradeMarkInfoQuery();
    useEffect(() => {
        if (!isLogin) {
            dispatch(
            setAlertModal({
                modalState: true,
                modalData: { title: "로그인이 필요합니다.", message: "로그인 페이지로 이동합니다." },
                callback: () => {
                navigate("/login");
                },
            })
            );
        } else {
            setUserName(Storage.get("humanName"));
            setEmail(Storage.get("accountKey"));
        }
    }, []);

    const handleSearch = async () => {
        const cleanedPatentNo = patentNo.replace(/-/g, "");
        const searchPatentNo = !cleanedPatentNo.trim() ? "KIPRIS" : cleanedPatentNo;
        triggerPatentSearch({ agentNo: myAttorneyNo, patentNo: searchPatentNo, humanName: userName });
    };

    const formatDate = (dateString) => {
        if (!dateString || dateString.length !== 8) return dateString;
        return `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`;
    };

    const handleDesignSearch = async () => {
        const searchText = designNo.trim() || userName;
        if (searchText) {
            triggerDesignSearch({ searchText });
        }
    };

    const handleTrademarkSearch = async () => {
        const searchText = trademarkNo.trim() || userName;
        if (searchText) {
            triggerTrademarkSearch({ searchText });
        }
    };


    return (
        <main style={{ minHeight: "800px", background: "#e5ecef" }}>
            <section>
            <Container className="container">
                <div className="row">
                    <div className="col-lg-3 col-12">
                        <UserInfo className="d-none d-lg-block">
                        <p className="user_name">{userName} 변리사</p>
                        <p className="user_email">{email}</p>
                        </UserInfo>

                        <MyPageMenu className="d-none d-lg-block">
                            <p className="title">마이페이지</p>
                            <ul>
                                <li>
                                <Link to={"/mypage"} className="active">
                                    매칭 정보
                                </Link>
                                </li>
                                <li>
                                <Link to={"/mypage/modify"}>회원정보 수정</Link>
                                </li>
                                <li>
                                <Link to={"/mypage/resumeModify"}>전문 정보 수정</Link>
                                </li>
                                <li>
                                <Link to="/mypage/patentInfo">
                                내 특허 정보 검색
                                </Link>
                                </li>
                                <li onClick={() => Storage.logout()}>
                                <Link>로그아웃</Link>
                                </li>
                            </ul>
                        </MyPageMenu>
                    </div>
                    <div className="col-lg-9 col-12 bg-white rounded shadow-sm">
                        <p className="fw-bold mb-2">상세 검색</p>
                        {/* tabs */}
                        <TabBar role="tablist" aria-label="검색 유형">
                            <TabButton
                                role="tab"
                                aria-selected={activeTab === TABS.PATENT}
                                className={activeTab === TABS.PATENT ? "active" : ""}
                                onClick={() => setActiveTab(TABS.PATENT)}
                            >
                                특허/실용신안
                            </TabButton>
                            <TabButton
                                role="tab"
                                aria-selected={activeTab === TABS.DESIGN}
                                className={activeTab === TABS.DESIGN ? "active" : ""}
                                onClick={() => setActiveTab(TABS.DESIGN)}
                            >
                                디자인
                            </TabButton>
                            <TabButton
                                role="tab"
                                aria-selected={activeTab === TABS.TRADEMARK}
                                className={activeTab === TABS.TRADEMARK ? "active" : ""}
                                onClick={() => setActiveTab(TABS.TRADEMARK)}
                            >
                                상표
                            </TabButton>
                        </TabBar>
                        {activeTab === TABS.PATENT && (
                            <div role="tabpanel" aria-label="특허/실용신안">
                                <h3>특허/실용신안 검색</h3>
                                <input
                                    type="text"
                                    placeholder="특허번호 입력"
                                    value={patentNo}
                                    onChange={(e) => {
                                        // 숫자만 허용
                                        const value = e.target.value.replace(/[^0-9]/g, "");
                                        setPatentNo(value);
                                    }}
                                    className="form-control mb-2" />
                                <button
                                    onClick={handleSearch}
                                    disabled={isFetching}
                                    className="btn btn-primary w-100 mb-2"
                                    style={isFetching ? { backgroundColor: '#6c757d', borderColor: '#6c757d', cursor: 'not-allowed' } : {}}>{patentNo == "" ? "내 기록 조회" : "특허 번호 조회"}</button>
                                {isFetching && <p>검색중...</p>}
                                {error && <p>오류가 발생했습니다. 다시 시도해주세요.</p>}
                                {data && (
                                    <div>
                                        <h3>검색 결과: {data.data?.length}건</h3>
                                        {data.data?.length > 0 && patentNo == "" && data.data.map((item, index) => (
                                            <div key={index} style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                                                <p><strong>발명명:</strong> {item.inventionTitle}</p>
                                                <p><strong>출원인:</strong> {item.applicantName}</p>
                                                <p><strong>IPC 번호:</strong> {item.ipcNumber}</p>
                                                <p><strong>등록상태:</strong> {item.registerStatus}</p>
                                                <p><strong>요약:</strong> {item.astrtCont}</p>
                                                <p><strong>출원번호:</strong> {item.applicationNumber}</p>
                                                <p><strong>출원일자:</strong> {item.applicationDate}</p>
                                                <p><strong>공개번호:</strong> {item.openNumber}</p>
                                                <p><strong>공개일자:</strong> {item.openDate}</p>
                                                <p><strong>등록번호:</strong> {item.registerNumber}</p>
                                                <p><strong>등록일자:</strong> {item.registerDate}</p>
                                                <p><strong>공개일자:</strong> {item.publicationDate}</p>
                                                {item.bigDrawing && (
                                                    <div>
                                                        <strong>도면:</strong>
                                                        <br />
                                                        <img src={item.bigDrawing} alt="도면 이미지" style={{ maxWidth: "100%", height: "auto" }} />
                                                    </div>
                                                )}
                                                <br />
                                                
                                            </div>
                                        )
                                        )}
                                        {data.data.resultData && patentNo != "" && (
                                            <div style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                                                <p><strong>발명명:</strong> {data.data.resultData.inventTitle}</p>
                                                <p><strong>출원인:</strong> {data.data.resultData.invntrNm}</p>
                                                <p><strong>IPC 번호:</strong> {data.data.resultData.ipcNumber}</p>
                                                <p><strong>등록상태:</strong> {data.data.resultData.lstDspslNm}</p>
                                                <p><strong>출원번호:</strong> {data.data.resultData.applNo}</p>
                                                <p><strong>출원일자:</strong> {data.data.resultData.applDate}</p>
                                                <p><strong>공개번호:</strong> {data.data.resultData.openNo}</p>
                                                <p><strong>공개일자:</strong> {data.data.resultData.openDate}</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {!data && !isFetching && <p>검색 결과가 없습니다.</p>}
                            </div>
                        )}
                        {activeTab === TABS.DESIGN && (
                            <div>
                                <h3>디자인 검색 결과</h3>
                                <input
                                    type="text"
                                    placeholder="검색어 입력(대리인)"
                                    value={designNo}
                                    onChange={(e) => setDesignNo(e.target.value)}
                                    className="form-control mb-2" />
                                <button
                                    onClick={handleDesignSearch}
                                    disabled={designIsFetching}
                                    className="btn btn-primary w-100 mb-2"
                                    style={designIsFetching ? { backgroundColor: '#6c757d', borderColor: '#6c757d', cursor: 'not-allowed' } : {}}>{designNo === "" ? "내 정보 조회" : "검색"}</button>
                                {designIsFetching && <p>검색중...</p>}
                                {designError && <p>오류가 발생했습니다. 다시 시도해주세요.</p>}
                                {designData && designData.data && (
                                    <div>
                                        <h3>검색 결과: {designData.data.length}건</h3>
                                        {designData.data.length > 0 ? (
                                            designData.data.map((item, index) => (
                                                <div key={index} style={{ borderBottom: "1px solid #ccc", padding: "20px 0" }}>
                                                    {item.imagePathLarge && (
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <img 
                                                                src={item.imagePathLarge} 
                                                                alt={item.articleName || "디자인 이미지"} 
                                                                style={{ maxWidth: "100%", height: "auto", border: "1px solid #ddd", borderRadius: "4px" }} 
                                                            />
                                                        </div>
                                                    )}
                                                    {item.agentName && <p><strong>변리사명:</strong> {item.agentName}</p>}
                                                    {item.applicantName && <p><strong>출원인:</strong> {item.applicantName}</p>}
                                                    {item.applicationDate && <p><strong>출원일자:</strong> {formatDate(item.applicationDate)}</p>}
                                                    {item.applicationNumber && <p><strong>출원번호:</strong> {item.applicationNumber}</p>}
                                                    {item.applicationStatus && <p><strong>출원상태:</strong> {item.applicationStatus}</p>}
                                                    {item.articleName && <p><strong>물품명:</strong> {item.articleName}</p>}
                                                    {item.designNumber && <p><strong>디자인 번호:</strong> {item.designNumber}</p>}
                                                    {item.designMainClassification && <p><strong>디자인 주분류:</strong> {item.designMainClassification}</p>}
                                                    {item.dsShpClssCd && <p><strong>디자인 부분류:</strong> {item.dsShpClssCd}</p>}
                                                    {item.inventorName && <p><strong>발명자:</strong> {item.inventorName}</p>}
                                                    {item.openDate && <p><strong>공개일자:</strong> {formatDate(item.openDate)}</p>}
                                                    {item.openNumber && <p><strong>공개번호:</strong> {item.openNumber}</p>}
                                                    {item.publicationDate && <p><strong>공고일자:</strong> {formatDate(item.publicationDate)}</p>}
                                                    {item.publicationNumber && <p><strong>공고번호:</strong> {item.publicationNumber}</p>}
                                                    {item.registrationDate && <p><strong>등록일자:</strong> {formatDate(item.registrationDate)}</p>}
                                                    {item.registrationNumber && <p><strong>등록번호:</strong> {item.registrationNumber}</p>}
                                                    {item.priorityDate && <p><strong>우선권 주장일:</strong> {formatDate(item.priorityDate)}</p>}
                                                    {item.priorityNumber && <p><strong>우선권 주장번호:</strong> {item.priorityNumber}</p>}
                                                    {item.internationalRegisterDate && <p><strong>국제등록일:</strong> {formatDate(item.internationalRegisterDate)}</p>}
                                                    {item.internationalRegisterNumber && <p><strong>국제등록번호:</strong> {item.internationalRegisterNumber}</p>}
                                                    {item.appReferenceNumber && <p><strong>출원 참조번호:</strong> {item.appReferenceNumber}</p>}
                                                    {item.regReferenceNumber && <p><strong>등록 참조번호:</strong> {item.regReferenceNumber}</p>}
                                                </div>
                                            ))
                                        ) : (
                                            <p>검색 결과가 없습니다.</p>
                                        )}
                                    </div>
                                )}
                                {designData && !designData.data && !designIsFetching && <p>검색 결과가 없습니다.</p>}
                            </div>
                        )}
                        {activeTab === TABS.TRADEMARK && (
                            <div>
                                <h3>상표 검색</h3>
                                <input
                                    type="text"
                                    placeholder="검색어 입력(대리인)"
                                    value={trademarkNo}
                                    onChange={(e) => setTrademarkNo(e.target.value)}
                                    className="form-control mb-2" />
                                <button
                                    onClick={handleTrademarkSearch}
                                    disabled={trademarkIsFetching}
                                    className="btn btn-primary w-100 mb-2"
                                    style={trademarkIsFetching ? { backgroundColor: '#6c757d', borderColor: '#6c757d', cursor: 'not-allowed' } : {}}>{trademarkNo === "" ? "내 정보 조회" : "검색"}</button>
                                {trademarkIsFetching && <p>검색중...</p>}
                                {trademarkError && <p>오류가 발생했습니다. 다시 시도해주세요.</p>}
                                {trademarkData && trademarkData.data && (
                                    <div>
                                        <h3>검색 결과: {trademarkData.data.length}건</h3>
                                        {trademarkData.data.length > 0 ? (
                                            trademarkData.data.map((item, index) => (
                                                <div key={index} style={{ borderBottom: "1px solid #ccc", padding: "20px 0" }}>
                                                    {item.bigDrawing && (
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <img 
                                                                src={item.bigDrawing} 
                                                                alt={item.title || "상표 이미지"} 
                                                                style={{ maxWidth: "100%", height: "auto", border: "1px solid #ddd", borderRadius: "4px" }} 
                                                            />
                                                        </div>
                                                    )}
                                                    {item.title && <p><strong>상표명:</strong> {item.title}</p>}
                                                    {item.agentName && <p><strong>변리사명:</strong> {item.agentName}</p>}
                                                    {item.applicantName && <p><strong>출원인:</strong> {item.applicantName}</p>}
                                                    {item.applicationDate && <p><strong>출원일자:</strong> {formatDate(item.applicationDate)}</p>}
                                                    {item.applicationNumber && <p><strong>출원번호:</strong> {item.applicationNumber}</p>}
                                                    {item.applicationStatus && <p><strong>출원상태:</strong> {item.applicationStatus}</p>}
                                                    {item.classificationCode && <p><strong>분류코드:</strong> {item.classificationCode}</p>}
                                                    {item.viennaCode && <p><strong>비엔나코드:</strong> {item.viennaCode}</p>}
                                                    {item.publicationDate && <p><strong>공고일자:</strong> {formatDate(item.publicationDate)}</p>}
                                                    {item.publicationNumber && <p><strong>공고번호:</strong> {item.publicationNumber}</p>}
                                                    {item.registrationDate && <p><strong>등록일자:</strong> {formatDate(item.registrationDate)}</p>}
                                                    {item.registrationNumber && <p><strong>등록번호:</strong> {item.registrationNumber}</p>}
                                                    {item.registrationPublicDate && <p><strong>등록공고일자:</strong> {formatDate(item.registrationPublicDate)}</p>}
                                                    {item.registrationPublicNumber && <p><strong>등록공고번호:</strong> {item.registrationPublicNumber}</p>}
                                                    {item.regPrivilegeName && <p><strong>등록권리자명:</strong> {item.regPrivilegeName}</p>}
                                                    {item.priorityDate && <p><strong>우선권 주장일:</strong> {formatDate(item.priorityDate)}</p>}
                                                    {item.priorityNumber && <p><strong>우선권 주장번호:</strong> {item.priorityNumber}</p>}
                                                    {item.internationalRegisterDate && <p><strong>국제등록일:</strong> {formatDate(item.internationalRegisterDate)}</p>}
                                                    {item.internationalRegisterNumber && <p><strong>국제등록번호:</strong> {item.internationalRegisterNumber}</p>}
                                                    {item.appReferenceNumber && <p><strong>출원 참조번호:</strong> {item.appReferenceNumber}</p>}
                                                    {item.regReferenceNumber && <p><strong>등록 참조번호:</strong> {item.regReferenceNumber}</p>}
                                                </div>
                                            ))
                                        ) : (
                                            <p>검색 결과가 없습니다.</p>
                                        )}
                                    </div>
                                )}
                                {trademarkData && !trademarkData.data && !trademarkIsFetching && <p>검색 결과가 없습니다.</p>}
                            </div>
                        )}
                    </div>
                </div>
            </Container>
            </section>
        </main>
    );
}

const Container = styled.div`
padding: 40px 0;

@media (max-width: 991px) {
    padding: 40px 0;
}
`;

const UserInfo = styled.div`
position: relative;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background-color: #fafbfe;
padding: 20px;

p.user_name {
    color: #070143;
    font-size: 25px;
    font-weight: 700;
    line-height: 1.2;
    padding: 3.4px 10px;
}
p.user_email {
    color: #687693;
    font-size: 15px;
    padding: 10px;
}
`;

const MyPageMenu = styled.div`
position: relative;
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
background-color: transparent;
margin-top: 65px;

p.title {
    color: #070143;
    font-size: 23px;
    padding-bottom: 10px;
    position: relative;
    margin-bottom: 30px;
    width: 100%;

    &::before {
    position: absolute;
    width: 55px;
    height: 4px;
    left: 0;
    bottom: 0;
    background-color: #202d90;
    border-radius: 10px;
    content: "";
    }

    &::after {
    position: absolute;
    width: calc(80% - calc(var(--bs-gutter-x) * 0.5));
    height: 4px;
    left: 65px;
    bottom: 0;
    background-color: #f2f2f2;
    border-radius: 10px;
    content: "";
    }
}

ul {
    li {
    font-size: 19px;
    position: relative;

    & + li {
        margin-top: 12px;
    }

    a {
        color: #687693;
        display: block;
        width: 100%;
        transition: color 0.3s ease-in-out;

        &:hover {
        color: #1b267b;
        }

        &.active {
        color: #1b267b;
        }
    }
    }
}
`;

// simple styled tab bar
const TabBar = styled.div`
    display: inline-flex;
    gap: 8px;
    background: #f4f6fa;
    border-radius: 10px;
    padding: 6px;
    `;

const TabButton = styled.button`
    border: 0;
    background: transparent;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 14px;
    color: #495665;
    cursor: pointer;

    &.active {
        background: #ffffff;
        color: #1b267b;
        box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        font-weight: 600;
    }

    &:hover {
        color: #1b267b;
    }
`;

export default Contents;